import { useQuery } from '@tanstack/react-query';

import { organizationApi } from '@/api/organization-admin/organization';
import { organizationDeviceKeys } from '../../api/query-keys/organization-devices';

export const useOrganizationDevices = () => {
  return useQuery({
    queryKey: organizationDeviceKeys.all,
    queryFn: organizationApi.fetchOrganizationDevices,
  });
};
